import {CellContext, ColumnDef} from '@tanstack/react-table';
import React from 'react';

import {ChevronSmallDown, ChevronSmallRight} from '../../assets/images';
import {EIconSmallButton} from '../EButtons';

import {ETableCell, ETableRow} from './types';

/** Expansion column specification. */
export function expansionColumn(): ColumnDef<ETableRow, ETableCell> {
  return {
    id: '_expander',
    header: '',
    enableSorting: false,
    cell: (ctx: CellContext<ETableRow, ETableCell>) => {
      if (!ctx.row.original.options?.expansion) {
        return null;
      }
      return (
        <EIconSmallButton onClick={ctx.row.getToggleExpandedHandler()}>
          {ctx.row.getIsExpanded() ? (
            <ChevronSmallDown />
          ) : (
            <ChevronSmallRight />
          )}
        </EIconSmallButton>
      );
    },
    meta: {
      SubCell: () => '', // No expander on an expanded row
    },
  };
}
